/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */

import axios from 'axios';

class Login implements MerchantosLogin {
  Submit = (login: string, password: string, formid: string) => {
    window.merchantos.login.lockSubmit();
    if (window.mixpanel) {
      const googleEvent = login === '@gmail.com' && formid === 'openid_form' ? 'Google ' : '';
      window.mixpanel.track(`WebPOS - Login Page - Button ${googleEvent}Sign In`);
    }
    // Set short timeout to make sure mixpanel event tracking is completed.
    // We fake this instead of using the `mixpanel.track` callback so we don't
    // risk breaking the login functionality if mixpanel is down.
    window.setTimeout(() => window.merchantos.login.getRedirect(login, password, formid), 300);
  };

  getRedirect = (login: string, password: string, formid: string) =>
    $.ajax({
      url: `https://${window.location.host}/ajax_forms.php`,
      type: 'POST',
      dataType: 'jsonp',
      timeout: 20000,
      data: {
        form_name: 'login_redirect',
        name: login,
        password,
        form_id: formid,
      },
    })
      .done(data => {
        if (data.message) {
          if (data.result && formid === 'emailpasswordreset') {
            $('form fieldset').hide();
          }
          window.displayMessage(data.message);
          return;
        }
        if (data.error) {
          window.displayError(data.error, true);
          return;
        }
        if (data.openid) {
          window.merchantos.login.openIDRedirect(data.redirect);
          return;
        }
        if (data.lsidOidcLoginRedirectEnabled && data.lsidAuthUri && data.lsidRedirectUri) {
          window.merchantos.login.lsidRedirect(
            login,
            password,
            data.lsidAuthUri,
            data.lsidRedirectUri
          );
          return;
        }
        if (data.host) {
          // Used for CLD-12096, clear the session data on new login
          if (sessionStorage) {
            sessionStorage.clear();
          }
          // even if the user has no redirect, we always get something back from the script
          window.merchantos.login.doLogin(login, password, data.host);
          return;
        }
        if (data.success_msg === false) {
          window.merchantos.login.loginIncorrect(data.failed_msg);
          return;
        }
        window.merchantos.login.loginIncorrect('An unknown error occurred.');
      })
      .fail(() => window.merchantos.login.unlockSubmit());

  lsidRedirect = (
    login: string,
    password: string,
    lsidAuthUri: string,
    lsidRedirectUri: string
  ) => {
    const form = $('<form />', { method: 'post', class: 'hidden' });
    const login_field = $('<input/>', {
      type: 'hidden',
      name: 'username',
      value: login,
    });
    const password_field = $('<input/>', {
      type: 'hidden',
      name: 'password',
      value: password,
    });

    const searchParams = new URLSearchParams(window.location.search);
    const redirectAfterLogin = searchParams.get('redirect_after_login');

    const redirectUriQueryString = redirectAfterLogin
      ? `?redirect_after_login=${encodeURIComponent(redirectAfterLogin)}`
      : '';

    const redirect_uri_field = $('<input/>', {
      type: 'hidden',
      name: 'redirect_uri',
      value: `${lsidRedirectUri}${redirectUriQueryString}`,
    });

    form.append(login_field);
    form.append(password_field);
    form.append(redirect_uri_field);

    form[0].action = lsidAuthUri;
    window.merchantos.debug(form);
    $('body').append(form);
    form.trigger('submit');
  };

  doLogin = (login: string, password: string, redirect: string) => {
    window.merchantos.debug(`redirect received: ${redirect}`);
    window.merchantos.debug(`do login: ${redirect}`);
    window.merchantos.login.submitLogin(login, password, redirect);
  };

  submitLogin = (login: string, password: string, host: string) => {
    const form = $('<form />', { method: 'post', class: 'hidden' });
    const login_field = $('<input/>', { type: 'hidden', name: 'login_name', value: login });
    const password_field = $('<input/>', {
      type: 'hidden',
      name: 'login_password',
      value: password,
    });
    const formname_field = $('<input/>', { type: 'hidden', name: 'form_name', value: 'login' });

    form.append(login_field);
    form.append(password_field);
    form.append(formname_field);

    const redirect_to = $('#login')
      .find('input[name="redirect_after_login"]')
      .val();
    if (redirect_to) {
      form.append($(`<input type="hidden" name="redirect_after_login" value="${redirect_to}" />`));
    }

    // NOTE: for local development use window.location.host (hostname:port) as the host instead.
    host = process.env.NODE_ENV === 'development' ? window.location.host : host;

    form[0].action = `https://${host}/register.php`;
    window.merchantos.debug(form);
    $('body').append(form);
    form.trigger('submit');
  };

  openIDRedirect = (redirect: string) => {
    window.merchantos.debug(`Open ID Redirect: ${redirect}`);
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Location'... Remove this comment to see the full error message
    window.location = redirect;
  };

  loginIncorrect = (msg: TSFixMe) => {
    window.displayError(msg);
    window.merchantos.login.unlockSubmit();
  };

  lockSubmit = () =>
    $('#login')
      .find('button[type="submit"]')
      .attr('disabled', 'disabled')
      .text('Working...');

  unlockSubmit = () =>
    $('#login')
      .find('button[type="submit"]')
      .prop('disabled', false)
      .text('Sign In');

  authorize = async (redirectAfterLogin?: string): Promise<void> => {
    const timeout = 3000;

    const oidcDataResponse = await axios.get('/auth/lsid/oidc-data', {
      timeout,
      validateStatus: status => status === 200,
      timeoutErrorMessage: `"/auth/lsid/oidc-data" timed out after ${timeout}ms`,
    });

    const oidcDataJson = oidcDataResponse.data;

    if (!oidcDataJson.lsidLoginEnabled) {
      throw new Error('LSID Login feature disabled. Fallback to legacy login flow.');
    }

    if (!oidcDataJson.lsidDomain || !oidcDataJson.redirect_uri || !oidcDataJson.client_id) {
      throw new Error('Invalid "/auth/lsid/oidc-data" response.');
    }

    const identityResponse = await axios.get(`${oidcDataJson.lsidDomain}/auth/identity`, {
      withCredentials: true,
      timeout,
      validateStatus: status => status === 200,
      timeoutErrorMessage: `"${oidcDataJson.lsidDomain}/auth/identity" timed out after ${timeout}ms`,
    });

    const identityJson = identityResponse.data;

    if (!identityJson.grants || !identityJson.grants.user || !identityJson.grants.user.retail) {
      throw new Error('Invalid "/auth/identity" response.');
    }

    const redirectUriQueryString = redirectAfterLogin
      ? `?redirect_after_login=${encodeURIComponent(redirectAfterLogin)}`
      : '';

    const redirectUri = `${oidcDataJson.redirect_uri}${redirectUriQueryString}`;

    const params = [
      `client_id=${oidcDataJson.client_id}`,
      // Here we are re-encoding the value on purpose: the `redirect_after_login`
      // query param should still be encoded after the first decode (so the URI is
      // safe to use as a redirection).
      `redirect_uri=${encodeURIComponent(redirectUri)}`,
      'response_type=code',
      'scope=openid',
      `state=${identityJson.jti}`,
      'product=retail',
    ];

    window.location.href = `${oidcDataJson.lsidDomain}/oidc/authorize?${params.join('&')}`;
  };
}

window.merchantos.login = new Login();

window.renderNotice = function renderNotice(message, title, type, insertion_point) {
  if (!title) {
    title = '';
  }

  const id = type === 'error' ? 'loginFailedMessage' : '';
  const alertType = type === 'error' ? 'danger' : type || 'info';
  const notice = $(
    `<div id="${id}" class="cr-alert cr-alert--${alertType} cr-mb-3 notice ${type}"><div class="cr-alert__content-wrap"><p class="cr-alert__content cr-m-0">${message}</p></div></div>`
  );

  // Default insertion point
  if (!insertion_point) insertion_point = $('section:visible').find('.block');

  // Let's work on the DOM
  $('.error, .notice').remove();
  insertion_point.before(notice);
  notice.hide().fadeIn();

  return notice;
};

window.displayMessage = function displayMessage(message) {
  window.renderNotice(message, '', 'success');
};

window.displayError = function displayError(message, no_fadeout, title) {
  if (!title) title = 'Error';

  const notice = window.renderNotice(message, title, 'error');

  if (no_fadeout) return;

  setTimeout(() => notice.fadeOut(), 10000);
  setTimeout(() => notice.remove(), 11000);
};

const urlParams: { [key: string]: any } = {};
$(() => {
  let reset_hashkey: string;

  // On iPad w/ landscape orientation focus will jump when keyboard pop event causes
  // field movement. By resetting scroll location when initial field gets focus we're
  // able to prevent field jump. See ticket #1698.

  // If this causes weird behavior on other platforms a iOS detection could be attempted
  // before running this event but in limited testing it didn't seem to cause issues
  // elsewhere.
  $('body').one('focus', 'input[name="login"]', () => window.scrollTo(0, 0));

  // Intercept Google login event
  $('.google').on('click', event => {
    event.preventDefault();
    window.merchantos.login.Submit('@gmail.com', '', 'openid_form');
    return false;
  });

  if (urlParams.error_message) {
    window.displayError(urlParams.error_message);
  }

  if (urlParams.redirect_after_login)
    $('input[name="redirect_after_login"]').val(urlParams.redirect_after_login);

  if (urlParams.prefill_user) $('input[name="login"]').val(urlParams.prefill_user);

  if (urlParams.prefill_pwd) $('input[name="password"]').val(urlParams.prefill_pwd);

  if ($('#login, #resetpassword, #emailpasswordreset').length > 0) {
    if (location.hash) {
      $.each(location.hash.replace('#', '').split(';'), (_, str) => {
        const param = str.split(':');
        if (param[0] === 'email') {
          ($('#login').find('input[name="login"]')[0] as HTMLInputElement).value = param[1];
          $('#login')
            .find('input[name="password"]')
            .trigger('focus');
        }
        if (param[0] === 'hashkey') {
          reset_hashkey = param[1];
        }
      });
    }
  }

  $('#login')
    .find('form')
    .on('submit', function onLoginFormSubmit(event) {
      event.preventDefault();

      const login = $(this)
        .find('input[name="login"]')
        .val() as string;
      const password = $(this)
        .find('input[name="password"]')
        .val() as string;
      window.merchantos.login.Submit(login, password, 'login_form');
      return false;
    });

  $('#resetpassword')
    .find('form')
    .on('submit', function onPasswordResetSubmit(event) {
      event.preventDefault();
      const password1 = $(this)
        .find('input[name="password1"]')
        .val() as string;
      const password2 = $(this)
        .find('input[name="password2"]')
        .val() as string;

      if (!reset_hashkey) {
        window.displayError(
          'Something happened to the link we sent you. Please try opening the link from your email again.'
        );
        return false;
      }
      if (password1 !== password2) {
        window.displayError(
          'Please re-enter your password. Password did not match against your verification of it.'
        );
        return false;
      }

      window.merchantos.login.Submit(`hashkey=${reset_hashkey}`, password1, 'resetpassword');
      return false;
    });

  $('#emailpasswordreset')
    .find('form')
    .on('submit', function onEmailPasswordReset(event) {
      event.preventDefault();
      const email = $(this)
        .find('input[name="email"]')
        .val() as string;

      window.merchantos.login.Submit('emailpasswordreset', email, 'emailpasswordreset');
      return false;
    });

  $('.js-input-autofocus').trigger('focus');

  /**
   * Mixpanel tracking
   * @todo Create re-usable module for mixpanel event tracking
   */
  const mixpanelIntervalId = window.setInterval(() => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'cookie' does not exist on type 'Mixpanel... Remove this comment to see the full error message
    if (!window.mixpanel || !window.mixpanel.cookie || !window.mixpanel.cookie.clear) {
      return;
    }

    const mixpanel = window.mixpanel;

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'cookie' does not exist on type 'Mixpanel... Remove this comment to see the full error message
    mixpanel.cookie.clear();

    mixpanel.register({ domain: window.location.href });
    $('.js-mixpanel').each(function trackMixpanel() {
      const el = $(this);
      const type = el.data('mixpanel-track-type');
      let eventName = el.data('mixpanel-event-name');
      if (type && eventName) {
        eventName = `WebPOS - Login Page - ${eventName}`;
        switch (type) {
          case 'link':
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement>' is not assi... Remove this comment to see the full error message
            mixpanel.track_links(el, eventName);
            break;
          default: {
            //
          }
        }
      }
    });

    window.clearInterval(mixpanelIntervalId);
  }, 50);
});

(() => {
  let e;

  const a = /\+/g;
  // Regex for replacing addition symbol with a space

  const r = /([^&=]+)=?([^&]*)/g;

  const d = (s: TSFixMe) => decodeURIComponent(s.replace(a, ' '));

  const q = window.location.search.substring(1);

  e = r.exec(q);
  while (e) {
    urlParams[d(e[1])] = sanitizeString(d(e[2]));
    e = r.exec(q);
  }

  /**
   * Sanitize special characters
   * @param {string} string
   * @returns {string} The sanitized string
   */
  function sanitizeString(string: TSFixMe) {
    const entityMap = {
      '"': '&#34;',
      '&': '&#38;',
      "'": '&#39;',
      '<': '&#60;',
      '>': '&#62;',
      '\\': '&#92;',
    };

    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return string.replace(/[&<>"'\\]/g, (s: TSFixMe) => entityMap[s]);
  }
})();

const tryAuthorize = async () => {
  try {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has('error')) {
      throw new Error('An error param was provided.');
    }

    await window.merchantos.login.authorize(searchParams.get('redirect_after_login') || undefined);
  } catch (err) {
    if (err.code === 'ECONNABORTED') {
      window.newrelic?.addPageAction('LSID authorize timeout', {
        page: 'login',
        context: err.message,
      });
    }

    // 1. Delete Loading Spinner
    const loadingContainer = document.querySelector<HTMLDivElement>(
      '.login-reskin__loading-container'
    );

    if (loadingContainer) {
      const parent = loadingContainer.parentNode;
      parent && parent.removeChild(loadingContainer);
    }

    // 2. and Show Form
    const formContainer = document.querySelector<HTMLDivElement>('.login-reskin__form');
    if (formContainer) {
      formContainer.style.visibility = 'visible';
    }
  }
};

tryAuthorize();
